import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Divider } from 'primereact/divider';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { IconField } from 'primereact/iconfield';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Slider } from "primereact/slider";

import { Checkbox } from 'primereact/checkbox';
        


export default function SidebarColetas(props) {
    const { 
            verInativos, 
            setVerInativos,
            verDesconectados, 
            setVerDesconectados, 
            verDescobertas, 
            setVerDescobertas, 
            faixaTonerCiano,
            setFaixaTonerCiano,
            faixaTonerMagenta,
            setFaixaTonerMagenta,
            faixaTonerAmarelo,
            setFaixaTonerAmarelo,
            faixaTonerPreto,
            setFaixaTonerPreto,
            isMobile
          } = props;
    const [open, setOpen] = useState(false)
    


    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">Opções de Consulta</span>
        </div>
    );

 
    return (
        <React.Fragment>
             <Button 
                    icon="pi pi-filter" 
                    className= "p-button-primary " 
                    onClick={() => setOpen(true)}
                    tooltip="Opção de filtros" tooltipOptions={{ position: 'bottom' }}
                />   
            <Sidebar 
                onHide={() => {
                    setOpen(false)
                }}
                header={customHeader} 
                visible={open} 
                style={{width:isMobile ? '100%': '20%'}} 
                position="right" 
                className="custom-sidebar"
                {...props}
            >
            <Divider/>   
                <div className='pl-4 pr-4'>
                    {/*
                    <Checkbox  
                        style={{marginTop : '10px'}}
                        checked={verInativos }
                        onChange={(e) => setVerInativos(e.checked)}/>
                    <span className="text-small mb-2  ml-1 mb-1">Visualizar equipamentos Desabilitados</span>                        
                <br/>                      
                <Checkbox  
                    style={{marginTop : '10px'}}
                    checked={verDesconectados}
                    onChange={(e) => setVerDesconectados(e.checked)}/>
                <span className="text-small mb-2 ml-1 mb-1">Visualizar equipamentos sem conexão</span>
                <br/>    
                <Checkbox  
                    style={{marginTop : '10px'}}
                    checked={verDescobertas}
                    onChange={(e) => setVerDescobertas(e.checked)}/>
                <span className="text-small mb-2  ml-1 mb-1" >Visualizar recém descobertos</span>
                     */}   

                <br/>
                <br/>
                <div className="flex flex-wrap gap-1 pr-0">
                    <div className="col-12 md:col-12">
                        <label htmlFor="inscEstadual">Setor/Syslocation</label>
                        <InputText
                            name="setor"
                            value={props.setor}
                            onChange={(e)=>props.setSetor(e.target.value)}
                            className="w-full mt-2"
                        />
                    </div>
                </div>
                <div className="flex flex-wrap gap-1 pr-0">
                    <div className="col-12 md:col-12">
                        <label htmlFor="inscEstadual">Endereço IP</label>
                        <InputText
                            name="setor"
                            value={props.enderecoIP}
                            onChange={(e)=>props.setEnderecoIP(e.target.value)}
                            className="w-full mt-2"
                        />
                    </div>
                </div>

                <div className="flex flex-wrap gap-1 pr-0">
                    <div className="col-12 md:col-12">
                        <label htmlFor="inscEstadual">Número Série (original)</label>
                        <InputText
                            name="numeroSerie"
                            value={props.numeroSerie}
                            onChange={(e)=>props.setNumeroSerie(e.target.value)}
                            className="w-full mt-2"
                        />
                    </div>
                </div>
                <br/>
                <label htmlFor="email">Filtrar por níveis de Toner</label>
                <div className='pr-3 pl-3'>                    
                    <br/>                           
                    <Slider value={faixaTonerCiano} onChange={(e) => setFaixaTonerCiano(e.value)} className="w-full  mt-3" range  />
                    <div className='texto-sm center w-full' style={{marginTop:'15px', fontSize: '14px',textAlign:'center'}}>Min: {faixaTonerCiano[0]} - Max: {faixaTonerCiano[1]}</div>
                    <br/>
                 
                </div>
                </div>
            </Sidebar>
            
        </React.Fragment>
    );
}
